import * as React from 'react';
import type {
  ScheduledProductRestrictionDataImportType as UploadType,
} from 'contracts/restricted-products/scheduled-data-imports';
import { usePermission } from 'hooks/usePermission';

const UPLOAD_TYPE_OPTIONS: Array<{ value: UploadType, name: string, requiredPermission?: string[] }> = [
  {
    value: 'blocked-products',
    name: 'Produtos restritos',
    requiredPermission: ['RES.BLOCKEDPRODUCTS.UPLOAD'],
  },
  {
    value: 'sale-movements',
    name: 'Movimentos de venda',
    requiredPermission: ['RES.SALEMOVEMENTS.IMPORT'],
  },
];

export const useUploadTypeOptions = () => {
  const { hasPermissionTo } = usePermission();

  return React.useMemo(() => {
    return UPLOAD_TYPE_OPTIONS.filter(({ requiredPermission }) => {
      return !requiredPermission || hasPermissionTo(requiredPermission);
    });
  }, [hasPermissionTo]);
};